import { z } from 'zod'
import { ErrorCode } from '~/types/error'

export const ngWordSchema = z.object({
  word: z.string().min(1, ErrorCode.REQUIRED).max(100, ErrorCode.TOO_LONG),
  isActive: z.boolean().default(true),
})

export type NgWordFormData = z.infer<typeof ngWordSchema>
